import { useCallback, useEffect, useMemo, useState } from 'react';
import './App.css';

const apiBaseUrl = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api/v1').replace(/\/$/, '');

const translations = {
  en: {
    api: 'API',
    allCategories: 'All categories',
    addToCart: 'Add to cart',
    apartment: 'Apartment',
    account: 'Account',
    accountDetails: 'Account details',
    accountSaved: 'Account details saved.',
    backToCart: 'Back to cart',
    bankTransfer: 'Bank transfer',
    bankTransferNote: 'Manual confirmation',
    cart: 'Your Cart',
    cartAria: 'Shopping cart',
    cartEmpty: 'Your cart is empty.',
    catalog: 'Catalog',
    checkout: 'Checkout',
    city: 'City',
    closeCart: 'Close cart',
    company: 'Company',
    country: 'Country',
    createOrder: 'Create order with fake payment',
    creatingOrder: 'Creating order...',
    demoCheckout: 'Secure-ish demo checkout',
    descriptionFallback: 'No description yet.',
    email: 'Email',
    fakeButton: 'Fake button, no redirect',
    fakePaymentEnabled: 'fake payment enabled',
    featured: 'Featured',
    fullName: 'Full name',
    haveAccount: 'Already have an account?',
    heroEyebrow: 'Single-shop catalog',
    heroTitle: 'Everything ready for your first catalog drop.',
    heroText: 'Browse products, place a test order, and manage stock from Django admin. Payment buttons are intentionally fake until real payment integration is added.',
    login: 'Log in',
    loginRegister: 'Log in / Register',
    logout: 'Log out',
    loadingProducts: 'Loading products...',
    noActiveProducts: 'No active products yet. Add products in Django admin.',
    noImage: 'No image',
    orderCreatedPrefix: 'Order',
    orderCreatedSuffix: 'created. Payment is fake for now, so the order is waiting for manual confirmation.',
    orderNote: 'Order note',
    password: 'Password',
    password2: 'Repeat password',
    phone: 'Phone',
    postalCode: 'Postal code',
    profileAbout: 'About me',
    productDetails: 'Product details',
    productLines: 'product line(s)',
    productNotFound: 'Product not found.',
    products: 'Products',
    proceed: 'Proceed to checkout',
    register: 'Register',
    saveDetails: 'Save details to my account',
    savedAddress: 'Saved address',
    searchProducts: 'Search products',
    shipping: 'Shipping',
    shippingCalculatedNext: 'Calculated next',
    shopProducts: 'Shop products',
    shoppingBag: 'Shopping bag',
    soldOut: 'Sold out',
    stock: 'Stock',
    streetAddress: 'Street address',
    subtotal: 'Subtotal',
    taxId: 'Tax/VAT ID',
    todayCheckout: "Today's checkout",
    total: 'Total',
    totalBeforeShipping: 'Total before shipping',
    trustAdmin: 'Admin order management',
    trustCatalog: 'Fast catalog setup',
    trustInventory: 'Inventory control',
    trustPayments: 'Fake PayPal / Przelewy24 / PayU',
    viewCart: 'View cart',
  },
  pl: {
    api: 'API',
    allCategories: 'Wszystkie kategorie',
    addToCart: 'Dodaj do koszyka',
    apartment: 'Mieszkanie / lokal',
    account: 'Konto',
    accountDetails: 'Dane konta',
    accountSaved: 'Dane konta zapisane.',
    backToCart: 'Wroc do koszyka',
    bankTransfer: 'Przelew bankowy',
    bankTransferNote: 'Reczne potwierdzenie',
    cart: 'Twoj koszyk',
    cartAria: 'Koszyk',
    cartEmpty: 'Koszyk jest pusty.',
    catalog: 'Katalog',
    checkout: 'Zamowienie',
    city: 'Miasto',
    closeCart: 'Zamknij koszyk',
    company: 'Firma',
    country: 'Kraj',
    createOrder: 'Zloz zamowienie z platnoscia testowa',
    creatingOrder: 'Tworzenie zamowienia...',
    demoCheckout: 'Testowe zamowienie',
    descriptionFallback: 'Brak opisu.',
    email: 'E-mail',
    fakeButton: 'Przycisk testowy, bez przekierowania',
    fakePaymentEnabled: 'platnosc testowa aktywna',
    featured: 'Polecane',
    fullName: 'Imie i nazwisko',
    haveAccount: 'Masz juz konto?',
    heroEyebrow: 'Katalog jednego sklepu',
    heroTitle: 'Wszystko gotowe na pierwszy katalog produktow.',
    heroText: 'Przegladaj produkty, zloz testowe zamowienie i zarzadzaj stanem magazynowym z panelu Django. Przyciski platnosci sa na razie testowe.',
    login: 'Zaloguj',
    loginRegister: 'Logowanie / Rejestracja',
    logout: 'Wyloguj',
    loadingProducts: 'Ladowanie produktow...',
    noActiveProducts: 'Brak aktywnych produktow. Dodaj produkty w panelu Django.',
    noImage: 'Brak zdjecia',
    orderCreatedPrefix: 'Zamowienie',
    orderCreatedSuffix: 'utworzone. Platnosc jest na razie testowa, wiec zamowienie czeka na reczne potwierdzenie.',
    orderNote: 'Notatka do zamowienia',
    password: 'Haslo',
    password2: 'Powtorz haslo',
    phone: 'Telefon',
    postalCode: 'Kod pocztowy',
    profileAbout: 'O mnie',
    productDetails: 'Szczegoly produktu',
    productLines: 'pozycja/e produktow',
    productNotFound: 'Nie znaleziono produktu.',
    products: 'Produkty',
    proceed: 'Przejdz do zamowienia',
    register: 'Zarejestruj',
    saveDetails: 'Zapisz dane na koncie',
    savedAddress: 'Zapisany adres',
    searchProducts: 'Szukaj produktow',
    shipping: 'Dostawa',
    shippingCalculatedNext: 'Obliczona w nastepnym kroku',
    shopProducts: 'Zobacz produkty',
    shoppingBag: 'Koszyk',
    soldOut: 'Wyprzedane',
    stock: 'Stan magazynowy',
    streetAddress: 'Ulica i numer',
    subtotal: 'Suma czesciowa',
    taxId: 'NIP / VAT ID',
    todayCheckout: 'Dzisiejsze zamowienie',
    total: 'Razem',
    totalBeforeShipping: 'Razem przed dostawa',
    trustAdmin: 'Zarzadzanie zamowieniami',
    trustCatalog: 'Szybka konfiguracja katalogu',
    trustInventory: 'Kontrola magazynu',
    trustPayments: 'Testowe PayPal / Przelewy24 / PayU',
    viewCart: 'Zobacz koszyk',
  },
};

const emptyAddress = {
  full_name: '',
  email: '',
  phone: '',
  country: 'Poland',
  city: '',
  postal_code: '',
  street_address: '',
  apartment: '',
  company: '',
  tax_id: '',
};

const emptyAuthForm = {
  full_name: '',
  email: '',
  phone_number: '',
  password: '',
  password2: '',
};

const authCookieName = 'shop_auth';
const authCookieMaxAge = 60 * 60 * 24 * 30;

function loadCart() {
  try {
    const parsed = JSON.parse(localStorage.getItem('shop_cart') || '[]');
    return Array.isArray(parsed) ? parsed : [];
  } catch (err) {
    localStorage.removeItem('shop_cart');
    return [];
  }
}

function setCookie(name, value, maxAgeSeconds) {
  document.cookie = `${name}=${encodeURIComponent(value)}; max-age=${maxAgeSeconds}; path=/; samesite=lax`;
}

function getCookie(name) {
  return document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${name}=`))
    ?.split('=')
    .slice(1)
    .join('=') || '';
}

function deleteCookie(name) {
  document.cookie = `${name}=; max-age=0; path=/; samesite=lax`;
}

function loadAuthTokens() {
  try {
    const storedAuth = getCookie(authCookieName) || localStorage.getItem(authCookieName) || 'null';
    const parsed = JSON.parse(decodeURIComponent(storedAuth));
    return parsed && parsed.refresh ? parsed : null;
  } catch (err) {
    localStorage.removeItem(authCookieName);
    deleteCookie(authCookieName);
    return null;
  }
}

function tokenExpiresSoon(token) {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return !payload.exp || payload.exp * 1000 < Date.now() + 60 * 1000;
  } catch (err) {
    return true;
  }
}

function loadLanguage() {
  const savedLanguage = localStorage.getItem('shop_language');
  return translations[savedLanguage] ? savedLanguage : 'en';
}

function getErrorMessage(payload) {
  if (!payload) {
    return 'Request failed.';
  }
  if (typeof payload === 'string') {
    return payload;
  }
  if (payload.detail) {
    return payload.detail;
  }
  const firstKey = Object.keys(payload)[0];
  const firstValue = firstKey ? payload[firstKey] : null;
  if (Array.isArray(firstValue)) {
    return `${firstKey}: ${firstValue.join(' ')}`;
  }
  if (firstValue && typeof firstValue === 'object') {
    return JSON.stringify(firstValue);
  }
  return firstValue ? `${firstKey}: ${firstValue}` : JSON.stringify(payload);
}

function money(value) {
  return `${Number(value || 0).toFixed(2)} PLN`;
}

function getProductImage(product) {
  return product.main_image || product.images?.[0]?.image || '';
}

function productText(product, field, language) {
  if (language === 'en') {
    return product[`${field}_en`] || product[field] || '';
  }
  return product[field] || product[`${field}_en`] || '';
}

function getProductSlugFromPath() {
  const match = window.location.pathname.match(/^\/product\/([^/]+)/);
  return match ? decodeURIComponent(match[1]) : '';
}

function getCurrentPath() {
  return window.location.pathname;
}

function App() {
  const [language, setLanguage] = useState(loadLanguage);
  const [products, setProducts] = useState([]);
  const [shippingMethods, setShippingMethods] = useState([]);
  const [cart, setCart] = useState(loadCart);
  const [address, setAddress] = useState(emptyAddress);
  const [shippingMethod, setShippingMethod] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('fake_paypal');
  const [customerNote, setCustomerNote] = useState('');
  const [query, setQuery] = useState('');
  const [category, setCategory] = useState('all');
  const [cartOpen, setCartOpen] = useState(false);
  const [authOpen, setAuthOpen] = useState(false);
  const [authMode, setAuthMode] = useState('login');
  const [authTokens, setAuthTokens] = useState(loadAuthTokens);
  const [authForm, setAuthForm] = useState(emptyAuthForm);
  const [account, setAccount] = useState(null);
  const [profileAbout, setProfileAbout] = useState('');
  const [accountMessage, setAccountMessage] = useState('');
  const [authError, setAuthError] = useState('');
  const [authSubmitting, setAuthSubmitting] = useState(false);
  const [productSlug, setProductSlug] = useState(getProductSlugFromPath);
  const [currentPath, setCurrentPath] = useState(getCurrentPath);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [order, setOrder] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const t = translations[language];
  const isCheckoutPage = currentPath === '/checkout';
  const isAccountPage = currentPath === '/account';
  const paymentMethods = [
    { id: 'fake_paypal', label: 'PayPal', note: t.fakeButton },
    { id: 'fake_przelewy24', label: 'Przelewy24', note: t.fakeButton },
    { id: 'fake_payu', label: 'PayU', note: t.fakeButton },
    { id: 'bank_transfer', label: t.bankTransfer, note: t.bankTransferNote },
  ];

  const refreshAuthTokens = useCallback(async () => {
    if (!authTokens?.refresh) {
      return null;
    }
    if (authTokens.access && !tokenExpiresSoon(authTokens.access)) {
      return authTokens;
    }

    const response = await fetch(`${apiBaseUrl}/user/token/refresh/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ refresh: authTokens.refresh }),
    });
    const payload = await response.json();
    if (!response.ok) {
      setAuthTokens(null);
      throw new Error(getErrorMessage(payload));
    }

    const nextTokens = {
      access: payload.access,
      refresh: payload.refresh || authTokens.refresh,
    };
    setAuthTokens(nextTokens);
    return nextTokens;
  }, [authTokens]);

  const apiFetch = useCallback(async (path, options = {}) => {
    const currentTokens = await refreshAuthTokens();
    const headers = { ...(options.headers || {}) };
    if (currentTokens?.access) {
      headers.Authorization = `Bearer ${currentTokens.access}`;
    }
    return fetch(`${apiBaseUrl}${path}`, { ...options, headers });
  }, [refreshAuthTokens]);

  useEffect(() => {
    localStorage.setItem('shop_cart', JSON.stringify(cart));
  }, [cart]);

  useEffect(() => {
    localStorage.setItem('shop_language', language);
  }, [language]);

  useEffect(() => {
    if (authTokens) {
      const serializedAuth = JSON.stringify(authTokens);
      setCookie(authCookieName, serializedAuth, authCookieMaxAge);
      localStorage.setItem(authCookieName, serializedAuth);
      return;
    }

    deleteCookie(authCookieName);
    localStorage.removeItem(authCookieName);
    setAccount(null);
  }, [authTokens]);

  useEffect(() => {
    if (!authTokens?.access) {
      return;
    }

    async function loadAccount() {
      try {
        const response = await apiFetch('/user/me/');
        const payload = await response.json();
        if (!response.ok) {
          throw new Error(getErrorMessage(payload));
        }
        setAccount(payload);
        setProfileAbout(payload.profile_about || '');
        if (payload.latest_address) {
          setAddress((current) => ({ ...current, ...payload.latest_address }));
        } else {
          setAddress((current) => ({
            ...current,
            full_name: current.full_name || payload.full_name || '',
            email: current.email || payload.email || '',
            phone: current.phone || payload.phone_number || '',
          }));
        }
      } catch (err) {
        setAuthTokens(null);
        setAuthError(err.message);
      }
    }

    loadAccount();
  }, [apiFetch, authTokens?.access]);

  useEffect(() => {
    function handlePopState() {
      setProductSlug(getProductSlugFromPath());
      setCurrentPath(getCurrentPath());
    }

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  useEffect(() => {
    async function loadShop() {
      try {
        const [productResponse, shippingResponse] = await Promise.all([
          fetch(`${apiBaseUrl}/products/`),
          fetch(`${apiBaseUrl}/shipping-methods/`),
        ]);

        if (!productResponse.ok || !shippingResponse.ok) {
          throw new Error('Could not load shop data.');
        }

        setProducts(await productResponse.json());
        const methods = await shippingResponse.json();
        setShippingMethods(methods);
        if (methods.length) {
          setShippingMethod(String(methods[0].id));
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }

    loadShop();
  }, []);

  const cartLines = useMemo(() => {
    return cart
      .map((line) => {
        const product = products.find((item) => item.id === line.product);
        return product ? { ...line, product } : null;
      })
      .filter(Boolean);
  }, [cart, products]);

  const categories = useMemo(() => {
    const names = products.map((product) => product.category_name).filter(Boolean);
    return Array.from(new Set(names)).sort();
  }, [products]);

  const visibleProducts = useMemo(() => {
    return products.filter((product) => {
      const matchesQuery = [
        productText(product, 'name', language),
        productText(product, 'short_description', language),
        productText(product, 'description', language),
        productText(product, 'long_description', language),
      ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase()
        .includes(query.toLowerCase());
      const matchesCategory = category === 'all' || product.category_name === category;
      return matchesQuery && matchesCategory;
    });
  }, [products, query, category, language]);

  const selectedProduct = useMemo(() => {
    return products.find((product) => product.slug === productSlug);
  }, [products, productSlug]);

  const cartQuantity = cartLines.reduce((sum, line) => sum + line.quantity, 0);
  const subtotal = cartLines.reduce((sum, line) => sum + Number(line.product.price) * line.quantity, 0);
  const selectedShipping = shippingMethods.find((method) => String(method.id) === String(shippingMethod));
  const shippingTotal = selectedShipping ? Number(selectedShipping.price) : 0;
  const total = subtotal + shippingTotal;

  function openCart() {
    setCartOpen(true);
  }

  function openHome(event) {
    if (event) {
      event.preventDefault();
    }
    window.history.pushState({}, '', '/');
    setProductSlug('');
    setCurrentPath('/');
    window.setTimeout(() => document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' }), 0);
  }

  function openAccount(event) {
    if (event) {
      event.preventDefault();
    }
    window.history.pushState({}, '', '/account');
    setProductSlug('');
    setCurrentPath('/account');
    setAuthOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function openProduct(product, event) {
    event.preventDefault();
    window.history.pushState({}, '', `/product/${product.slug}`);
    setProductSlug(product.slug);
    setCurrentPath(`/product/${product.slug}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function openCheckoutWindow() {
    const checkoutWindow = window.open(`${window.location.origin}/checkout`, '_blank');
    if (checkoutWindow) {
      checkoutWindow.opener = null;
      setCartOpen(false);
      return;
    }

    window.location.href = '/checkout';
  }

  function addToCart(product) {
    setOrder(null);
    openCart();
    setCart((current) => {
      const existing = current.find((line) => line.product === product.id);
      if (existing) {
        return current.map((line) => line.product === product.id ? { ...line, quantity: line.quantity + 1 } : line);
      }
      return [...current, { product: product.id, quantity: 1 }];
    });
  }

  function updateQuantity(productId, quantity) {
    if (quantity < 1) {
      setCart((current) => current.filter((line) => line.product !== productId));
      return;
    }
    setCart((current) => current.map((line) => line.product === productId ? { ...line, quantity } : line));
  }

  function updateAddress(event) {
    const { name, value } = event.target;
    setAddress((current) => ({ ...current, [name]: value }));
  }

  function updateAuthForm(event) {
    const { name, value } = event.target;
    setAuthForm((current) => ({ ...current, [name]: value }));
  }

  function logout() {
    setAuthTokens(null);
    setAccount(null);
    setAuthForm(emptyAuthForm);
    setProfileAbout('');
    setAccountMessage('');
    setAuthError('');
    if (currentPath === '/account') {
      openHome();
    }
  }

  async function submitAuth(event) {
    event.preventDefault();
    setAuthError('');
    setAccountMessage('');
    setAuthSubmitting(true);

    try {
      if (authMode === 'register') {
        const registerResponse = await fetch(`${apiBaseUrl}/user/register/`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(authForm),
        });
        const registerPayload = await registerResponse.json();
        if (!registerResponse.ok) {
          throw new Error(getErrorMessage(registerPayload));
        }
      }

      const loginResponse = await fetch(`${apiBaseUrl}/user/token/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: authForm.email,
          password: authForm.password,
        }),
      });
      const loginPayload = await loginResponse.json();
      if (!loginResponse.ok) {
        throw new Error(getErrorMessage(loginPayload));
      }

      setAuthTokens(loginPayload);
      setAuthOpen(false);
      setAuthForm(emptyAuthForm);
    } catch (err) {
      setAuthError(err.message);
    } finally {
      setAuthSubmitting(false);
    }
  }

  async function saveAccountDetails(event) {
    if (event) {
      event.preventDefault();
    }
    setError('');
    setAccountMessage('');

    try {
      const response = await apiFetch('/user/me/', {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          full_name: address.full_name,
          phone_number: address.phone,
          profile_about: profileAbout,
          address,
        }),
      });
      const payload = await response.json();
      if (!response.ok) {
        throw new Error(getErrorMessage(payload));
      }

      setAccount(payload);
      setAccountMessage(t.accountSaved);
    } catch (err) {
      setError(err.message);
    }
  }

  async function submitCheckout(event) {
    event.preventDefault();
    setError('');
    setSubmitting(true);

    try {
      const response = await apiFetch('/checkout/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: cart.map((line) => ({ product: line.product, quantity: line.quantity })),
          shipping_method: shippingMethod || null,
          payment_method: paymentMethod,
          customer_note: customerNote,
          billing_address: address,
        }),
      });

      const payload = await response.json();
      if (!response.ok) {
        throw new Error(JSON.stringify(payload));
      }

      setOrder(payload);
      setCart([]);
      setCustomerNote('');
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <main className="shop" lang={language}>
      <header className="topbar">
        <a className="brand" href="/" onClick={openHome}>
          <span>DS</span>
          Django Shop
        </a>
        <nav>
          <button className="cart-button" type="button" onClick={() => openCart()}>
            {t.cart} <span>{cartQuantity}</span>
          </button>
          {account ? (
            <button className="account-button" type="button" onClick={openAccount}>
              {account.full_name || account.email}
            </button>
          ) : (
            <button className="account-button" type="button" onClick={() => setAuthOpen(true)}>
              {t.loginRegister}
            </button>
          )}
          <div className="language-toggle" aria-label="Language">
            <button type="button" className={language === 'en' ? 'active' : ''} onClick={() => setLanguage('en')}>EN</button>
            <button type="button" className={language === 'pl' ? 'active' : ''} onClick={() => setLanguage('pl')}>PL</button>
          </div>
        </nav>
      </header>

      {!productSlug && !isCheckoutPage && !isAccountPage && (
        <>
          <section className="hero">
            <div>
              <p className="eyebrow">{t.heroEyebrow}</p>
              <h1>{t.heroTitle}</h1>
              <p>{t.heroText}</p>
              <div className="hero-actions">
                <a href="#products" onClick={openHome}>{t.shopProducts}</a>
                <button className="secondary" type="button" onClick={() => openCart()}>
                  {t.viewCart}
                </button>
              </div>
            </div>
            <div className="hero-card">
              <span>{t.todayCheckout}</span>
              <strong>{money(total)}</strong>
              <p>{cartLines.length} {t.productLines}, {t.fakePaymentEnabled}</p>
            </div>
          </section>
        </>
      )}

      {error && <div className="notice error">{error}</div>}
      {order && (
        <div className="notice success">
          {t.orderCreatedPrefix} <strong>{order.order_number}</strong> {t.orderCreatedSuffix}
        </div>
      )}

      {productSlug ? (
        <section className="product-detail-wrap">
          {loading && <p>{t.loadingProducts}</p>}
          {!loading && !selectedProduct && <p>{t.productNotFound}</p>}
          {selectedProduct && (
            <article className="product-detail">
              <div className="product-detail-media">
                {getProductImage(selectedProduct) ? (
                  <img src={getProductImage(selectedProduct)} alt={productText(selectedProduct, 'name', language)} />
                ) : (
                  <span>{t.noImage}</span>
                )}
              </div>
              <div className="product-detail-info">
                <button className="link-button" type="button" onClick={openHome}>{t.products}</button>
                <p className="eyebrow">{t.productDetails}</p>
                <h1>{productText(selectedProduct, 'name', language)}</h1>
                <p className="detail-description">
                  {productText(selectedProduct, 'description', language) || productText(selectedProduct, 'short_description', language) || t.descriptionFallback}
                </p>
                <dl className="detail-meta">
                  {selectedProduct.category_name && <div><dt>{t.catalog}</dt><dd>{selectedProduct.category_name}</dd></div>}
                  <div><dt>{t.stock}</dt><dd>{selectedProduct.stock_quantity}</dd></div>
                </dl>
                <div className="detail-buy">
                  <div>
                    <strong>{money(selectedProduct.price)}</strong>
                    {selectedProduct.compare_at_price && <del>{money(selectedProduct.compare_at_price)}</del>}
                  </div>
                  <button type="button" onClick={() => addToCart(selectedProduct)} disabled={!selectedProduct.is_in_stock}>
                    {selectedProduct.is_in_stock ? t.addToCart : t.soldOut}
                  </button>
                </div>
              </div>
              {(productText(selectedProduct, 'long_description', language) || productText(selectedProduct, 'description', language)) && (
                <section className="long-description">
                  <p className="eyebrow">{t.productDetails}</p>
                  <h2>{productText(selectedProduct, 'name', language)}</h2>
                  <p>{productText(selectedProduct, 'long_description', language) || productText(selectedProduct, 'description', language)}</p>
                </section>
              )}
            </article>
          )}
        </section>
      ) : isCheckoutPage ? (
        <section className="checkout-page">
          <div className="section-head">
            <div>
              <p className="eyebrow">{t.demoCheckout}</p>
              <h1>{t.checkout}</h1>
            </div>
            <button className="secondary-page-button" type="button" onClick={openHome}>
              {t.backToCart}
            </button>
          </div>

          <div className="checkout-page-grid">
            <form className="checkout-form" onSubmit={submitCheckout}>
              <div className="form-grid">
                <input required name="full_name" placeholder={t.fullName} value={address.full_name} onChange={updateAddress} />
                <input required name="email" type="email" placeholder={t.email} value={address.email} onChange={updateAddress} />
                <input name="phone" placeholder={t.phone} value={address.phone} onChange={updateAddress} />
                <input required name="country" placeholder={t.country} value={address.country} onChange={updateAddress} />
                <input required name="city" placeholder={t.city} value={address.city} onChange={updateAddress} />
                <input required name="postal_code" placeholder={t.postalCode} value={address.postal_code} onChange={updateAddress} />
                <input required className="wide" name="street_address" placeholder={t.streetAddress} value={address.street_address} onChange={updateAddress} />
                <input name="apartment" placeholder={t.apartment} value={address.apartment} onChange={updateAddress} />
                <input name="company" placeholder={t.company} value={address.company} onChange={updateAddress} />
                <input name="tax_id" placeholder={t.taxId} value={address.tax_id} onChange={updateAddress} />
              </div>

              <label className="field">
                {t.shipping}
                <select value={shippingMethod} onChange={(event) => setShippingMethod(event.target.value)}>
                  {shippingMethods.map((method) => (
                    <option key={method.id} value={method.id}>
                      {method.name} - {money(method.price)}
                    </option>
                  ))}
                </select>
              </label>

              <div className="fake-payments">
                {paymentMethods.map((method) => (
                  <button
                    type="button"
                    className={paymentMethod === method.id ? 'selected' : ''}
                    key={method.id}
                    onClick={() => setPaymentMethod(method.id)}
                  >
                    <strong>{method.label}</strong>
                    <span>{method.note}</span>
                  </button>
                ))}
              </div>

              <textarea placeholder={t.orderNote} value={customerNote} onChange={(event) => setCustomerNote(event.target.value)} />

              {account && (
                <button className="secondary-action" type="button" onClick={saveAccountDetails}>
                  {t.saveDetails}
                </button>
              )}
              {accountMessage && <p className="inline-success">{accountMessage}</p>}

              <button className="primary" type="submit" disabled={cartLines.length === 0 || submitting}>
                {submitting ? t.creatingOrder : t.createOrder}
              </button>
            </form>

            <aside className="checkout-summary">
              <p className="eyebrow">{t.shoppingBag}</p>
              <h2>{t.cart}</h2>
              {cartLines.length === 0 ? (
                <p>{t.cartEmpty}</p>
              ) : (
                <div className="cart-lines">
                  {cartLines.map((line) => (
                    <div className="cart-line" key={line.product.id}>
                      <div>
                        <strong>{productText(line.product, 'name', language)}</strong>
                        <span>{line.quantity} x {money(line.product.price)}</span>
                      </div>
                      <strong>{money(Number(line.product.price) * line.quantity)}</strong>
                    </div>
                  ))}
                </div>
              )}

              <dl className="totals">
                <div><dt>{t.subtotal}</dt><dd>{money(subtotal)}</dd></div>
                <div><dt>{t.shipping}</dt><dd>{money(shippingTotal)}</dd></div>
                <div><dt>{t.total}</dt><dd>{money(total)}</dd></div>
              </dl>
            </aside>
          </div>
        </section>
      ) : isAccountPage ? (
        <section className="account-page">
          <div className="section-head">
            <div>
              <p className="eyebrow">{t.account}</p>
              <h1>{t.accountDetails}</h1>
            </div>
            <button className="secondary-page-button" type="button" onClick={openHome}>
              {t.products}
            </button>
          </div>

          {account ? (
            <form className="account-page-grid" onSubmit={saveAccountDetails}>
              <section className="account-card">
                <p className="eyebrow">{t.accountDetails}</p>
                <div className="form-grid">
                  <input required name="full_name" placeholder={t.fullName} value={address.full_name} onChange={updateAddress} />
                  <input name="phone" placeholder={t.phone} value={address.phone} onChange={updateAddress} />
                  <input className="wide" name="email" type="email" placeholder={t.email} value={account.email} readOnly />
                  <textarea className="wide" placeholder={t.profileAbout} value={profileAbout} onChange={(event) => setProfileAbout(event.target.value)} />
                </div>
              </section>

              <section className="account-card">
                <p className="eyebrow">{t.savedAddress}</p>
                <div className="form-grid">
                  <input required name="country" placeholder={t.country} value={address.country} onChange={updateAddress} />
                  <input required name="city" placeholder={t.city} value={address.city} onChange={updateAddress} />
                  <input required name="postal_code" placeholder={t.postalCode} value={address.postal_code} onChange={updateAddress} />
                  <input required className="wide" name="street_address" placeholder={t.streetAddress} value={address.street_address} onChange={updateAddress} />
                  <input name="apartment" placeholder={t.apartment} value={address.apartment} onChange={updateAddress} />
                  <input name="company" placeholder={t.company} value={address.company} onChange={updateAddress} />
                  <input name="tax_id" placeholder={t.taxId} value={address.tax_id} onChange={updateAddress} />
                </div>
                {accountMessage && <p className="inline-success">{accountMessage}</p>}
                <div className="account-actions">
                  <button className="primary" type="submit">{t.saveDetails}</button>
                  <button className="secondary-action" type="button" onClick={logout}>{t.logout}</button>
                </div>
              </section>
            </form>
          ) : (
            <section className="account-card">
              <p>{t.haveAccount}</p>
              <button className="primary" type="button" onClick={() => setAuthOpen(true)}>
                {t.loginRegister}
              </button>
            </section>
          )}
        </section>
      ) : (
        <section className="layout">
          <div className="products" id="products">
            <div className="section-head">
              <div>
                <p className="eyebrow">{t.catalog}</p>
                <h2>{t.products}</h2>
              </div>
              <div className="filters">
                <input value={query} onChange={(event) => setQuery(event.target.value)} placeholder={t.searchProducts} />
                <select value={category} onChange={(event) => setCategory(event.target.value)}>
                  <option value="all">{t.allCategories}</option>
                  {categories.map((name) => <option key={name} value={name}>{name}</option>)}
                </select>
              </div>
            </div>
            {loading && <p>{t.loadingProducts}</p>}
            {!loading && products.length === 0 && <p>{t.noActiveProducts}</p>}
            <div className="product-grid">
              {visibleProducts.map((product) => (
                <article className="product" key={product.id}>
                  <a className="product-image" href={`/product/${product.slug}`} onClick={(event) => openProduct(product, event)}>
                    {getProductImage(product) ? <img src={getProductImage(product)} alt={productText(product, 'name', language)} /> : <span>{t.noImage}</span>}
                    {product.is_featured && <b>{t.featured}</b>}
                  </a>
                  <h3>
                    <a className="product-title-link" href={`/product/${product.slug}`} onClick={(event) => openProduct(product, event)}>
                      {productText(product, 'name', language)}
                    </a>
                  </h3>
                  {product.category_name && <span className="pill">{product.category_name}</span>}
                  <p>{productText(product, 'short_description', language) || productText(product, 'description', language) || t.descriptionFallback}</p>
                  <div className="product-footer">
                    <div>
                      <strong>{money(product.price)}</strong>
                      {product.compare_at_price && <del>{money(product.compare_at_price)}</del>}
                    </div>
                    <button type="button" onClick={() => addToCart(product)} disabled={!product.is_in_stock}>
                      {product.is_in_stock ? t.addToCart : t.soldOut}
                    </button>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>
      )}

      {authOpen && (
        <div className="modal-overlay" role="dialog" aria-modal="true" aria-label={t.account}>
          <button className="modal-backdrop" type="button" aria-label={t.closeCart} onClick={() => setAuthOpen(false)} />
          <section className="account-modal">
            <div className="drawer-head">
              <div>
                <p className="eyebrow">{t.account}</p>
                <h2>{account ? (account.full_name || account.email) : t.loginRegister}</h2>
              </div>
              <button className="icon-button" type="button" aria-label={t.closeCart} onClick={() => setAuthOpen(false)}>x</button>
            </div>

            {account ? (
              <div className="account-panel">
                <p>{account.email}</p>
                <button className="secondary-action" type="button" onClick={logout}>{t.logout}</button>
              </div>
            ) : (
              <form className="account-form" onSubmit={submitAuth}>
                <div className="auth-tabs" role="tablist" aria-label={t.account}>
                  <button type="button" className={authMode === 'login' ? 'active' : ''} onClick={() => setAuthMode('login')}>
                    {t.login}
                  </button>
                  <button type="button" className={authMode === 'register' ? 'active' : ''} onClick={() => setAuthMode('register')}>
                    {t.register}
                  </button>
                </div>

                {authMode === 'register' && (
                  <>
                    <input name="full_name" placeholder={t.fullName} value={authForm.full_name} onChange={updateAuthForm} />
                    <input name="phone_number" placeholder={t.phone} value={authForm.phone_number} onChange={updateAuthForm} />
                  </>
                )}
                <input required name="email" type="email" placeholder={t.email} value={authForm.email} onChange={updateAuthForm} />
                <input required name="password" type="password" placeholder={t.password} value={authForm.password} onChange={updateAuthForm} />
                {authMode === 'register' && (
                  <input required name="password2" type="password" placeholder={t.password2} value={authForm.password2} onChange={updateAuthForm} />
                )}

                {authError && <p className="inline-error">{authError}</p>}
                <button className="primary" type="submit" disabled={authSubmitting}>
                  {authMode === 'register' ? t.register : t.login}
                </button>
              </form>
            )}
          </section>
        </div>
      )}

      {cartOpen && (
        <div className="cart-overlay" role="dialog" aria-modal="true" aria-label={t.cartAria}>
          <button className="cart-backdrop" type="button" aria-label={t.closeCart} onClick={() => setCartOpen(false)} />
          <aside className="checkout">
            <div className="drawer-head">
              <div>
                <p className="eyebrow">{t.shoppingBag}</p>
                <h2>{t.cart}</h2>
              </div>
              <button className="icon-button" type="button" aria-label={t.closeCart} onClick={() => setCartOpen(false)}>x</button>
            </div>

            {cartLines.length === 0 ? (
              <p>{t.cartEmpty}</p>
            ) : (
              <div className="cart-lines">
                {cartLines.map((line) => (
                  <div className="cart-line" key={line.product.id}>
                    <div>
                      <strong>{productText(line.product, 'name', language)}</strong>
                      <span>{money(line.product.price)}</span>
                    </div>
                    <input
                      aria-label={`Quantity for ${productText(line.product, 'name', language)}`}
                      min="0"
                      type="number"
                      value={line.quantity}
                      onChange={(event) => updateQuantity(line.product.id, Number(event.target.value))}
                    />
                  </div>
                ))}
              </div>
            )}

            <dl className="totals">
              <div><dt>{t.subtotal}</dt><dd>{money(subtotal)}</dd></div>
              <div><dt>{t.shipping}</dt><dd>{t.shippingCalculatedNext}</dd></div>
              <div><dt>{t.totalBeforeShipping}</dt><dd>{money(subtotal)}</dd></div>
            </dl>

            <button className="primary" type="button" disabled={cartLines.length === 0} onClick={openCheckoutWindow}>
              {t.proceed}
            </button>
          </aside>
        </div>
      )}
    </main>
  );
}

export default App;
